// extracted by mini-css-extract-plugin
export default {"logo_img_box":"Skills_logo_img_box__o8yBU","img":"Skills_img__RnNdS","head":"Skills_head__ocPhW","grid":"Skills_grid__UKiyw","para":"Skills_para__1cKBl"};